import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonCustomized from "./ButtonCustomized";

const PopupDialogCustomized = (props) => {
  const {
    open,
    onClose,
    title,
    description,
    primaryButtonLabel,
    onPrimaryButtonClick,
    secondaryButtonLabel,
    onSecondaryButtonClick,
  } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ textAlign: "center" }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ margin: 2, marginTop: 0 }}>
        {primaryButtonLabel && (
          <ButtonCustomized
            title={primaryButtonLabel}
            onClick={onPrimaryButtonClick}
            color="primary"
            variant="contained"
          />
        )}
        {secondaryButtonLabel && (
          <ButtonCustomized
            title={secondaryButtonLabel}
            onClick={onSecondaryButtonClick}
            color="secondary"
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PopupDialogCustomized;
